import { TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import JSONInput from 'react-json-editor-ajrm';
// @ts-ignore
import locale from 'react-json-editor-ajrm/locale/en';
// @ts-ignore
import * as reallyRelaxedJson from 'really-relaxed-json/src/index.js';

interface IProps {
  id: string;
  name: string;
  defaultValue: Record<string, any>;
  height?: string;
  width?: string;
}

type JSONContentValues = {
  jsObject: Record<string, any>;
  error?: any;
};

export const JSONControl = ({
  id,
  name,
  defaultValue,
  height = '300px',
  width = '100%',
}: IProps) => {
  const { control, setValue } = useFormContext();

  const paste = (e: any) => {
    e.preventDefault();
    let obj = null;

    try {
      obj = JSON.parse(reallyRelaxedJson.toJson(e.target.value));
    } catch (e) {
      console.log('paste error', e);
    }
    if (obj && typeof obj === 'object') {
      setValue(name, obj);
    }
    e.target.value = '';
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        return (
          <div>
            <TextField
              size="small"
              placeholder="Paste to replace"
              onChange={paste}
              variant="standard"
            />
            <br />
            <JSONInput
              id={id}
              placeholder={value}
              waitAfterKeyPress={2000}
              onChange={(content: JSONContentValues) => {
                // This prevents clearing the value when JSON is temporarily invalid (e.g., pressing Enter mid-edit)
                if (
                  content.jsObject !== undefined &&
                  content.jsObject !== null &&
                  typeof content.jsObject === 'object'
                ) {
                  console.log('content.jsObject', content.jsObject);
                  onChange(content.jsObject);
                } else {
                  console.error('Invalid JSON detected:', content.error);
                  console.log(content, 'error content');
                }
              }}
              locale={locale}
              theme="light_mitsuketa_tribute"
              height={height}
              width={width}
              style={{
                body: {
                  fontSize: '1rem',
                },
              }}
            />
          </div>
        );
      }}
    />
  );
};
